import {
  FETCH_YADS_TENANT_SCENARIOS_REQUEST,
  FETCH_YADS_TENANT_SCENARIOS_SUCCESS,
  FETCH_YADS_TENANT_SCENARIOS_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  tenantOptions: [],
  scenarioGroups: [],
  error: '',
};

const yadsTenantScenarioReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_YADS_TENANT_SCENARIOS_REQUEST:
      return { ...state, loading: true };
    case FETCH_YADS_TENANT_SCENARIOS_SUCCESS:
      return {
        loading: false,
        tenantOptions: action.payload.tenantOptions,
        scenarioGroups: action.payload.scenarioGroups,
        error: '',
      };
    case FETCH_YADS_TENANT_SCENARIOS_FAILURE:
      return { loading: false, tenantOptions: [], scenarioGroups: [], error: action.payload };
    default:
      return state;
  }
};

export default yadsTenantScenarioReducer;
